import { useEffect, useState } from 'react';
import { subMonths } from 'date-fns';
import { getCrmLeadsChartsData } from '../../../../services/api';
import { LineConfig, TransformedDataPoint } from '../helpers/prepareChartData';
import { startOfDay, endOfDay } from 'date-fns';
import { prepareLeadsChartData } from '../helpers/prepareLeadsChartData';
import { useTranslation } from 'react-i18next';

type CrmLeadsChartsDbData = {
  date: string;
  statuses: {
    status: string;
    count: number;
  }[];
};

export const useCrmLeadsChartsData = () => {
  const { t } = useTranslation();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [chartsData, setChartsData] = useState<TransformedDataPoint[] | null>(null);
  const [chartsLines, setChartsLines] = useState<LineConfig[] | null>(null);

  const fetchData = async (from: string, to: string) => {
    console.log('Fetching data with from:', from, 'to:', to);
    setLoading(true);
    setError(null);
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const rawData: CrmLeadsChartsDbData[] = await getCrmLeadsChartsData(from, to, timezone);
      console.log('Fetched leads charts data:', rawData);
      const { data, lines } = prepareLeadsChartData(rawData);
      // localize line names so chart component displays translated labels
      const localizedLines = lines.map((l) => ({
        ...l,
        name: t(`global.selectorStatus.${l.name}`, { defaultValue: l.name }),
      }));
      console.log('Prepared leads charts data:', data, 'lines:', localizedLines);
      setChartsData(data);
      setChartsLines(localizedLines);
      console.log('Set leads charts data and lines', { chartsData: data, chartsLines: lines });
    } catch (err) {
      console.error('Error fetching leads charts data:', err);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTo(new Date().toISOString().split('T')[0]); // Set default to date to today
    const monthAgo = subMonths(new Date(), 1).toISOString().split('T')[0];
    setFrom(monthAgo);
    fetchData(monthAgo, new Date().toISOString().split('T')[0]);
  }, []);

  return {
    from,
    setFrom,
    to,
    setTo,
    error,
    setError,
    chartsData,
    loading,
    setLoading,
    fetchData,
    chartsLines,
  };
};
